import { useState } from 'react'
import User from 'singletons/User'

import EditPage from './EditPage'
import ViewPage from './ViewPage'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

const Account = () => {
  const [currentEditSection, setCurrentEditSection] = useState<'general' | 'profile' | null>(null)

  return (
    <div
      className={classNames(
        'flex justify-center px-6 sm:px-10 pt-8 pb-10 bg-white',
        !currentEditSection && 'md:justify-end ',
      )}
    >
      {!!currentEditSection && !!User.provider && (
        <EditPage currentSection={currentEditSection} onClose={() => setCurrentEditSection(null)} />
      )}
      {!currentEditSection && <ViewPage onEditModeChange={setCurrentEditSection} />}
    </div>
  )
}

export default Account
